import { OriginModel } from "../../models/medical-record/origin.model";

export class OriginStruct {
    public originNotDefault: OriginModel;
    public isCreate: boolean;
    constructor() {
        this.originNotDefault = new OriginModel();
    }
}